__turbopack_context__.v({
  "cards": "_4v0KNa_cards",
  "container": "_4v0KNa_container",
  "containerCard": "_4v0KNa_containerCard",
  "h3Platform": "_4v0KNa_h3Platform",
  "image": "_4v0KNa_image",
  "imageContainer": "_4v0KNa_imageContainer",
  "pPlatform": "_4v0KNa_pPlatform",
  "paragraph": "_4v0KNa_paragraph",
  "rowEtc": "_4v0KNa_rowEtc",
  "textCategory": "_4v0KNa_textCategory",
  "textH2": "_4v0KNa_textH2",
  "title": "_4v0KNa_title",
});
